import React from "react";
import MuiDialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import Fade from "@material-ui/core/Fade";
import withStyles from "../../../styles/withStyles";

let SlideTransition = React.forwardRef((props, ref) => (
  <Slide direction="up" {...props} ref={ref} />
));

function Dialog({ classes, TransitionComponent, children, ...props }) {
  let contentClass = props.fullScreen
    ? classes.fullScreenRoot
    : classes.defaultRoot;
  let transition = (() => {
    if (TransitionComponent) return TransitionComponent;
    if (props.fullScreen) return SlideTransition;
    return Fade;
  })();

  return (
    <MuiDialog
      classes={{ paperFullScreen: classes.paperFullScreen }}
      TransitionComponent={transition}
      {...props}
    >
      <DialogContent classes={{ root: contentClass }}>{children}</DialogContent>
    </MuiDialog>
  );
}

let styles = theme => ({
  paperFullScreen: {
    marginTop: "80px"
  },
  defaultRoot: {
    padding: "0 30px 22px",
    "&:first-child": {
      paddingTop: "24px"
    }
  },
  fullScreenRoot: {
    height: "100%",
    display: "grid",
    gridTemplateRows: "auto 1fr auto",
    gridTemplateColumns: "100%",
    padding: "50px 75px 100px"
  }
});

export default withStyles(styles)(Dialog);
